<template>
  <template v-if="mode === 'edit'">
 
    <v-sheet v-for="col in meta.columns" :key="col"> 
      {{ col.fieldname }}
    </v-sheet>

  </template>    

  <template v-if="mode === 'view'">

    <standard-sis-data-material v-bind="{mode:'view', meta:meta, value:value}"></standard-sis-data-material>
<!-- <template v-if="meta.description.includes('sis_standard')">
  <standard-sis-data-material v-bind="{mode:'view', meta:meta, value:value}"></standard-sis-data-material>
</template> -->
<!--description must be contains full word without spaces-->
<!--см куда происходит переход с таблицы Видов - если прикрепление к более базовой таблице (Link to specimen) - тогда смотреть дескрпишен в этой таблице-->

<!-- <template v-if="meta.description.includes('lichen_species_main')">
  <standard-data-material v-bind="{mode:'view', meta:meta, value:value}"></standard-data-material>
</template> -->

<!-- <template v-else-if="this.$store.state.metaPrint.description.includes('lichen_species_main')">
  <list-standard-print-page v-bind="{mode:'view', meta:this.$store.state.metaPrint, rows:this.$store.state.rowsToPrint}"></list-standard-print-page>
</template>

<template v-else-if="this.$store.state.metaPrint.description.includes('sis_standard')">
  <sis-standard-print-page v-bind="{mode:'view', meta:this.$store.state.metaPrint, rows:this.$store.state.rowsToPrint}"></sis-standard-print-page>
</template> -->


  </template>

  <template v-else>
      {{v}}
  </template>
  
</template>

<script>
import StandardSisDataMaterial from '@/views/StandardSisDataMaterial.vue';
export default {
    name: 'BaseSisDataMaterial',
    props:['mode','meta', 'value'],
    emits: ['update:modelValue'],
    data(){ 
        return {
        }
    }, 
    
    components: {
      StandardSisDataMaterial,


    },

    methods:{
      


    },




}
</script>